/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import './TabNavigation.scss';

function TabsNavigation({ children, tabItems, activeTabIndex, updateTab }) {
  return (
    <div className="tabsNavigator__container">
      <div className="tabsNavigator__inner">
        <div className="tabsNavigator__navLeft">
          {tabItems?.map((tab, i) => (
            <div role="tab" key={tab} className="tabsNavigator__innerNavItem">
              <div
                className={`hover hover-3  ${
                  activeTabIndex === i && 'tabsNavigator__menuItemActive'
                }`}
                onClick={() => updateTab(i, tab)}
                data-cy={`aq-${tab.replace(/ /g, '')}-tab`}
              >
                {tab}
              </div>
            </div>
          ))}
        </div>
        <div className="tabsNavigator__navRight">{children}</div>
      </div>
    </div>
  );
}

TabsNavigation.propTypes = {
  children: PropTypes.node,
  tabItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  updateTab: PropTypes.func.isRequired,
};

export default TabsNavigation;
